import { h } from "preact";

import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";

import styles from "./Toggle.module.css";

interface Props {
    class?: string;
    style?: CSSProperties;
    checked: boolean;
    disabled?: boolean;
    onChange?: (ev: Event) => void;
}

function Toggle({
    class: cssClass,
    style,
    checked,
    disabled,
    onChange
}: Props) {
    return (
        <label
            class={classname(styles.toggle, cssClass, {
                [styles.checked]: checked,
                [styles.disabled]: disabled
            })}
            style={style}>
            <input class={styles.toggleInput} type="checkbox" checked={checked} onChange={onChange}/>
            <div class={styles.toggleKnob}/>
        </label>
    );
}

export default Toggle;
